import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import 'isomorphic-fetch';
import { Heading } from './NavMenu';
import { clearSubmissionState, loadSubmissionHistory} from '../actions/SubmissionActions';
import { UserState } from '../interface/MyInterfaces';
import { SubmissionState } from '../interface/SubmissionInterface';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ApplicationState } from '../reducers/Index';
import ReactDOM from 'react-dom';
import {
    Accordion,
    AccordionItem,
    AccordionItemTitle,
    AccordionItemBody,
} from 'react-accessible-accordion';

import 'react-accessible-accordion/dist/minimal-example.css';
import 'react-accessible-accordion/dist/fancy-example.css';
import { formatDate } from './Common/Helpers';
import SubAccordionBody from './SubAccordionBody';
export interface SubmissionsProps {
    UserState?: UserState;
    SubmissionState?: SubmissionState;
    loadSubmissionHistory?(display_id);
    get_classification_classified?(display_id);
    get_classification_unclassified?(display_id);
    clearSubmissionState?();
    item?: any;
    classified?: any;
    unclassified?: any;
    data?: any;
    index?: number;
    isOpen?: any;
    onClick?(index);
    bodyData?: any;
    bodyItem?: any;
    selectedOptionAll?: string;
    checkAll?: boolean;
}


class Submissions extends React.Component<RouteComponentProps<{}> & SubmissionsProps, SubmissionState> {
    constructor(props) {
        super(props);
        this.getFileType_Date = this.getFileType_Date.bind(this);
        this.state = {
            isOpen: [false, false, false, false, false, false, false]
        };
    }
    componentDidMount() {
        this.props.loadSubmissionHistory(this.props.UserState.display_id);
    }
    getFileType_Date(fileType) {
        var last_submitted = "-";
        if (this.props.SubmissionState !== undefined) {
            
            var submissionHistory = this.props.SubmissionState.SubmissionFileHistory;
            if (submissionHistory !== undefined) {
                var history = submissionHistory.filter(x => x.fileType == fileType);
                if (history !== undefined && history[0] !== undefined) {
                    var date = new Date(history[0].submissionDate);
                    last_submitted = date.toLocaleDateString("en-US", { year: 'numeric', month: 'long', day: 'numeric' })
                }
            }
        }
        return last_submitted;
    }
    getFilteredFileHistory(fileType) {
        //filter file type
        if (this.props.SubmissionState !== undefined) {

            const submissionHistory = this.props.SubmissionState.SubmissionFileHistory;
            if (submissionHistory !== undefined) {
                const filteredFileHistory = submissionHistory.filter((record) => {
                    return record.fileType == fileType;
                });
                return filteredFileHistory;
            }
        }
        
    }
    onChange = (index) => {
        const isOpen = this.state.isOpen;
        isOpen[index - 1] = !this.state.isOpen[index - 1];
        this.setState({ isOpen });
    }
    public render() {
        var award_last_submitted = (this.props.SubmissionState !== undefined) ? this.getFileType_Date("AWARD") : "-";
        var vendor_last_submitted = (this.props.SubmissionState !== undefined) ? this.getFileType_Date("VENDOR") : "-";
        var subaward_last_submitted = (this.props.SubmissionState !== undefined) ? this.getFileType_Date("SUBAWARD") : "-";
        var employee_last_submitted = (this.props.SubmissionState !== undefined) ? this.getFileType_Date("EMPLOYEE") : "-";
        var empname_last_submitted = (this.props.SubmissionState !== undefined) ? this.getFileType_Date("EMPNAME") : "-";
        var objcode_last_submitted = (this.props.SubmissionState !== undefined) ? this.getFileType_Date("OBJCODE") : "-";
        var suborg_last_submitted = (this.props.SubmissionState !== undefined) ? this.getFileType_Date("SUBORG") : "-";
        var awardidentity_last_submitted = (this.props.SubmissionState !== undefined) ? this.getFileType_Date("AWARDIDENTITY") : "-";
        var coinvestigator_last_submitted = (this.props.SubmissionState !== undefined) ? this.getFileType_Date("COINVESTIGATOR") : "-";

        var award_file_type = "award";
        var vendor_file_type = "vendor";
        var subaward_file_type = "subaward";
        var employee_file_type = "employee";
        var empname_file_type = "empname";
        var objcode_file_type = "objcode";
        var suborg_file_type = "suborg";
        var awardidentity_file_type = "awardidentity";
        var coinvestigator_file_type = "coinvestigator";

        return <div className='reports container-fluid'>
            <div className="row">
                <div className="col-md-12">
                    <Heading value='Submissions' />
                    <Accordion className="submissionstable" onChange={this.onChange}>
                        <AccordionItem>
                            <AccordionItemTitle>
                                <th>File Type</th>
                                <th>Last Submitted</th>
                                <th></th>
                            </AccordionItemTitle>
                        </AccordionItem>
                        <AccordionItem>
                            <AccordionItemTitle>
                                <td>Award</td>
                                <td>{award_last_submitted}</td>
                                <td>
                                    <NavLink onClick={() => this.props.clearSubmissionState()} to={`/submissions/upload_details/${award_file_type}`}>Upload</NavLink>
                                </td>
                                {this.state.isOpen[0] ? <i className="fa fa-angle-up"></i> : <i className="fa fa-angle-down"></i>}
                            </AccordionItemTitle>
                            <AccordionItemBody>
                                {this.props.SubmissionState && this.props.SubmissionState.SubmissionFileHistory &&
                                    <SubAccordionBody filteredFileHistory={this.getFilteredFileHistory("AWARD")} />
                                }
                            </AccordionItemBody>
                        </AccordionItem>
                        <AccordionItem>
                            <AccordionItemTitle>
                                <td>Vendor</td>
                                <td>{vendor_last_submitted}</td>
                                <td>
                                    <NavLink onClick={() => this.props.clearSubmissionState()} to={`/submissions/upload_details/${vendor_file_type}`}>Upload</NavLink>
                                    
                                </td>
                                {this.state.isOpen[1] ? <i className="fa fa-angle-up"></i> : <i className="fa fa-angle-down"></i>}
                            </AccordionItemTitle>
                            <AccordionItemBody>
                                {this.props.SubmissionState && this.props.SubmissionState.SubmissionFileHistory &&
                                    <SubAccordionBody filteredFileHistory={this.getFilteredFileHistory("VENDOR")} />
                                }
                            </AccordionItemBody>
                        </AccordionItem>
                        <AccordionItem>
                            <AccordionItemTitle>
                                <td>Subaward</td>
                                <td>{subaward_last_submitted}</td>
                                <td>
                                    <NavLink onClick={() => this.props.clearSubmissionState()} to={`/submissions/upload_details/${subaward_file_type}`}>Upload</NavLink>
                                </td>
                                {this.state.isOpen[2] ? <i className="fa fa-angle-up"></i> : <i className="fa fa-angle-down"></i>}
                            </AccordionItemTitle>
                            <AccordionItemBody>
                                {this.props.SubmissionState && this.props.SubmissionState.SubmissionFileHistory &&
                                    <SubAccordionBody filteredFileHistory={this.getFilteredFileHistory("SUBAWARD")} />
                                }
                            </AccordionItemBody>
                        </AccordionItem>
                        <AccordionItem>
                            <AccordionItemTitle>
                                <td>Employee</td>
                                <td>{employee_last_submitted}</td>
                                <td>
                                    <NavLink onClick={() => this.props.clearSubmissionState()} to={`/submissions/upload_details/${employee_file_type}`}>Upload</NavLink>
                                </td>
                                {this.state.isOpen[3] ? <i className="fa fa-angle-up"></i> : <i className="fa fa-angle-down"></i>}
                            </AccordionItemTitle>
                            <AccordionItemBody>
                                {this.props.SubmissionState && this.props.SubmissionState.SubmissionFileHistory &&
                                    <SubAccordionBody filteredFileHistory={this.getFilteredFileHistory("EMPLOYEE")} />
                                }
                            </AccordionItemBody>
                        </AccordionItem>
                        <AccordionItem>
                            <AccordionItemTitle>
                                <td>Employee Name</td>
                                <td>{empname_last_submitted}</td>
                                <td>
                                    <NavLink onClick={() => this.props.clearSubmissionState()} to={`/submissions/upload_details/${empname_file_type}`}>Upload</NavLink>
                                </td>
                                {this.state.isOpen[4] ? <i className="fa fa-angle-up"></i> : <i className="fa fa-angle-down"></i>}
                            </AccordionItemTitle>
                            <AccordionItemBody>
                                {this.props.SubmissionState && this.props.SubmissionState.SubmissionFileHistory &&
                                    <SubAccordionBody filteredFileHistory={this.getFilteredFileHistory("EMPNAME")} />
                                }
                            </AccordionItemBody>
                        </AccordionItem>
                        <AccordionItem>
                            <AccordionItemTitle>
                                <td>Object Codes</td>
                                <td>{objcode_last_submitted}</td>
                                <td>
                                    <NavLink onClick={() => this.props.clearSubmissionState()} to={`/submissions/upload_details/${objcode_file_type}`}>Upload</NavLink>
                                </td>
                                {this.state.isOpen[5] ? <i className="fa fa-angle-up"></i> : <i className="fa fa-angle-down"></i>}
                            </AccordionItemTitle>
                            <AccordionItemBody>
                                {this.props.SubmissionState && this.props.SubmissionState.SubmissionFileHistory &&
                                    <SubAccordionBody filteredFileHistory={this.getFilteredFileHistory("OBJCODE")} />
                                }
                            </AccordionItemBody>
                        </AccordionItem>
                        <AccordionItem>
                            <AccordionItemTitle>
                                <td>Organizational Units</td>
                                <td>{suborg_last_submitted}</td>
                                <td>
                                    <NavLink onClick={() => this.props.clearSubmissionState()} to={`/submissions/upload_details/${suborg_file_type}`}>Upload</NavLink>
                                </td>
                                {this.state.isOpen[6] ? <i className="fa fa-angle-up"></i> : <i className="fa fa-angle-down"></i>}
                            </AccordionItemTitle>
                            <AccordionItemBody>
                                {this.props.SubmissionState && this.props.SubmissionState.SubmissionFileHistory &&
                                    <SubAccordionBody filteredFileHistory={this.getFilteredFileHistory("SUBORG")} />
                                }
                            </AccordionItemBody>
                        </AccordionItem>
                        <AccordionItem>
                            <AccordionItemTitle>
                                <td>Award Identity</td>
                                <td>{awardidentity_last_submitted}</td>
                                <td>
                                    <NavLink onClick={() => this.props.clearSubmissionState()} to={`/submissions/upload_details/${awardidentity_file_type}`}>Upload</NavLink>
                                </td>
                                {this.state.isOpen[6] ? <i className="fa fa-angle-up"></i> : <i className="fa fa-angle-down"></i>}
                            </AccordionItemTitle>
                            <AccordionItemBody>
                                {this.props.SubmissionState && this.props.SubmissionState.SubmissionFileHistory &&
                                    <SubAccordionBody filteredFileHistory={this.getFilteredFileHistory("AWARDIDENTITY")} />
                                }
                            </AccordionItemBody>
                        </AccordionItem>
                        <AccordionItem>
                            <AccordionItemTitle>
                                <td>Co-investigators</td>
                                <td>{coinvestigator_last_submitted}</td>
                                <td>
                                    <NavLink onClick={() => this.props.clearSubmissionState()} to={`/submissions/upload_details/${coinvestigator_file_type}`}>Upload</NavLink>
                                </td>
                                {this.state.isOpen[6] ? <i className="fa fa-angle-up"></i> : <i className="fa fa-angle-down"></i>}
                            </AccordionItemTitle>
                            <AccordionItemBody>
                                {this.props.SubmissionState && this.props.SubmissionState.SubmissionFileHistory &&
                                    <SubAccordionBody filteredFileHistory={this.getFilteredFileHistory("COINVESTIGATORS")} />
                                }
                            </AccordionItemBody>
                        </AccordionItem>
                    </Accordion>
                </div>
            </div>
        </div>;
    }
}

const mapStateToProps = (state: ApplicationState) => ({
    UserState: state.userProperties,
    SubmissionState: state.submissionProperties
});


function matchDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            clearSubmissionState: clearSubmissionState,
            loadSubmissionHistory: loadSubmissionHistory
        }, dispatch
    )
}


export default connect(
    mapStateToProps, // Selects which state properties are merged into the component's props
    matchDispatchToProps
)(Submissions);